import { connect } from 'react-redux';
import MultiLocationFilter from './multi-location-filter';
import {
  setComparisonDateRange,
  removeComparisonDateRange,
} from '../../../reducers/filter.reducers';
import {
  removeReportData,
  selectLocation,
} from '../../../reducers/reports.reducers';

const mapStateToProps = state => ({
  locations: state.reports.locations,
  selectedReport: state.reports.selectedReport,
  selectedLocation: state.reports.selectedLocation,
  comparisonDateRanges: state.filter.comparisonDateRanges,
});

const mapDispatchToProps = dispatch => ({
  selectLocation: locationId => dispatch(selectLocation(locationId)),
  setComparisonDateRange: startAndEndDate => dispatch(setComparisonDateRange(startAndEndDate)),
  removeComparisonDateRange: comparisonId => dispatch(removeComparisonDateRange(comparisonId)),
  removeReportData: comparisonId => dispatch(removeReportData(comparisonId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiLocationFilter);
